import React from 'react';

import { Consent } from 'src/reducers/partner/types';

import { timeStampFormat } from 'Utilities/helpers';
import i18n from 'Utilities/i18n';

type Props = {
  connected: Consent;
};

const ConnectedOn: React.FC<React.PropsWithChildren<Props>> = ({ connected }) => {
  return (
    <span id="connected-text" className="mb-1 text-black text-semiBold d-block">
      {i18n.t('PartnersGeneric.connectedOn', {
        date: timeStampFormat(connected.created, 'fullDashed', 'hourMinute'),
      })}
    </span>
  );
};

export default ConnectedOn;
